import { h } from "preact";
import { useEffect } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import {
  fetchCompanyUsers,
  selectAreCompanyUsersLoaded,
  selectCompanyUserById,
  selectCompanyUsersLoadingError,
  setLoading,
} from "../store";
import i18n from "../i18n";

import AppFocusLayout from "../components/AppFocusLayout.jsx";
import Alert from "../components/Alert.jsx";
import Button from "../components/Button.jsx";
import Icon from "../components/Icon.jsx";
import TaskList from "../components/TaskList.jsx";
import CandidateItem from "../components/companies/CandidateItem.jsx";

export default function RelocationCasePage(props) {
  const dispatch = useDispatch();
  const params = useParams();
  const user = useSelector(selectCompanyUserById(params.userId));
  const usersLoaded = useSelector(selectAreCompanyUsersLoaded);
  const usersLoadingError = useSelector(selectCompanyUsersLoadingError);

  useEffect(async () => {
    dispatch(setLoading(true));
    await dispatch(fetchCompanyUsers());
    dispatch(setLoading(false));
  }, []);

  const closer = (
    <Button text to={`/relocation`}>
      <Icon>close</Icon>
    </Button>
  );

  if (usersLoadingError) {
    return (
      <AppFocusLayout
        title={i18n.t("pages.titles.relocation_case")}
        closerAction={closer}
      >
        <Alert error>{i18n.t("errors.could_not_load_company_users")}</Alert>
      </AppFocusLayout>
    );
  }

  if (usersLoaded && user) {
    return (
      <AppFocusLayout
        title={i18n.t("pages.titles.relocation_case")}
        closerAction={closer}
      >
        <CandidateItem user={user} class="mb-48" />
        <TaskList user={user} tasks={user.tasks} noLink />
      </AppFocusLayout>
    );
  }
  return (
    <AppFocusLayout
      title={i18n.t("pages.titles.relocation_case")}
      closerAction={closer}
    ></AppFocusLayout>
  );
}
